module.exports = __webpack_public_path__ + "img/favorite.a3372386.svg";